module.exports = __webpack_public_path__ + "src/assets/fonts/hero-pro-full-v2.eot?7581482c46f19f027e1b0fd1942ea2f6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/hero-pro-full-v2.eot
// module id = 970
// module chunks = 1